import BasePage from "@Scripts/Pages/BasePage";

export default class WorldwidePage extends BasePage {
    public static async init() {
        await super.init();
        this.setMap();
    }

    private static setMap() {
        var googleMaps,
            infowindow,
            initZoom = 2,
            icoSizeWidth = 42,
            icoSizeHeight = 54,
            initLatitude = $("input[name = \"InitLatitude\"]").val(),
            initLongitude = $("input[name = \"InitLongitude\"]").val(),
            isMapTypeControl = false,
            isZoomControl = true,
            isStreetViewControl = false,
            isScrollWheel = false,
            isKeyboardShortcuts = true,
            isPanControl = false,
            isDisableDoubleClickZoom = false,
            styles = [{
                featureType: "all",
                elementType: "all",
                stylers: [
                    { saturation: -70 }
                ]
            }];

        // if ((<any>window).App.device.isTablet.matches) {
        //     initZoom = 2;
        //     icoSizeWidth = 28;
        //     icoSizeHeight = 36;
        //     isZoomControl = false;
        // }

        // if ((<any>window).App.device.isSmartphone.matches) {
        //     initZoom = 1;
        //     icoSizeWidth = 21;
        //     icoSizeHeight = 27;
        //     isZoomControl = false;
        // }

        setGoogleMarkers();

        function initialize() {
            var mapOptions = {
                zoom: initZoom,
                center: new (<any>window).google.maps.LatLng(initLatitude, initLongitude),
                mapTypeControlOptions: {
                    mapTypeIds: [(<any>window).google.maps.MapTypeId.ROADMAP, "styles"]
                },
                mapTypeControl: isMapTypeControl,
                zoomControl: isZoomControl,
                streetViewControl: isStreetViewControl,
                scrollwheel: isScrollWheel,
                disableDoubleClickZoom: isDisableDoubleClickZoom,
                keyboardShortcuts: isKeyboardShortcuts,
                panControl: isPanControl
            };

            googleMaps = new (<any>window).google.maps.Map(document.getElementById("GoogleMaps"), mapOptions);

            googleMaps.mapTypes.set("styles", new (<any>window).google.maps.StyledMapType(styles, { name: "Styles" }));
            googleMaps.setMapTypeId("styles");

            $.each($(".google-maps-marker"), function (i) {
                var markerIcon = $("input[name = \"MarkerIcon\"]", this).val(),
                    markerLatitude = $("input[name = \"Latitude\"]", this).val(),
                    markerLongitude = $("input[name = \"Longitude\"]", this).val(),
                    markerTitle = $("input[name = \"MarkerTitle\"]", this).val(),
                    markerContents = $(".infowindow", this).html();

                if (!markerIcon) {
                    markerIcon = "google-maps-marker@2x.png";
                }

                var latlng = new (<any>window).google.maps.LatLng(markerLatitude, markerLongitude);
                googleMaps.addMarker(createMarker(markerTitle, markerIcon, markerContents, latlng));
            });

            function createMarker(name, icon, contents, latlng) {
                var marker = new (<any>window).google.maps.Marker({
                    title: name,
                    position: latlng,
                    map: googleMaps,
                    icon: new (<any>window).google.maps.MarkerImage("/images/" + icon, null, null, null, new (<any>window).google.maps.Size(icoSizeWidth, icoSizeHeight))
                });

                (<any>window).google.maps.event.addListener(marker, "click", function () {
                    if (infowindow) infowindow.close();
                    infowindow = new (<any>window).google.maps.InfoWindow({ content: contents });
                    infowindow.open(googleMaps, marker);
                });

                (<any>window).google.maps.event.addListener(googleMaps, "click", function () {
                    if (infowindow) infowindow.close();
                });

                return marker;
            }
        }

        (<any>window).google.maps.event.addDomListener(window, "load", initialize);

        function setGoogleMarkers() {
            (<any>window).google.maps.Map.prototype.markers = new Array();

            (<any>window).google.maps.Map.prototype.addMarker = function (marker) {
                this.markers[this.markers.length] = marker;
            };

            (<any>window).google.maps.Map.prototype.getMarkers = function () {
                return this.markers;
            };

            (<any>window).google.maps.Map.prototype.clearMarkers = function () {
                if (infowindow)
                    infowindow.close();

                for (var i = 0; i < this.markers.length; i++) {
                    this.markers[i].set_map(null);
                }
            };
        }
    }
}